module.exports = __webpack_public_path__ + "static/img/Jagga.209c15a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jagga.jpg
// module id = fudA
// module chunks = 0